var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 9,
    viewBox: "0 0 15 9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_55084",
    "data-name": "Path 55084",
    d: "M7.5,6.154A9.117,9.117,0,0,0,.066,10.411a.473.473,0,0,0,0,.482A9.117,9.117,0,0,0,7.5,15.154a9.125,9.125,0,0,0,7.436-4.261.473.473,0,0,0,0-.482A9.127,9.127,0,0,0,7.5,6.154Zm0,.976a7.586,7.586,0,0,1,6.356,3.523A7.585,7.585,0,0,1,7.5,14.179a7.572,7.572,0,0,1-6.351-3.527A7.573,7.573,0,0,1,7.5,7.13Zm0,1.029a2.494,2.494,0,1,0,2.542,2.494A2.523,2.523,0,0,0,7.5,8.159Zm0,.975a1.518,1.518,0,1,1-1.539,1.518A1.524,1.524,0,0,1,7.5,9.134Z",
    transform: "translate(0 -6.154)",
    fill: "#606060"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreview);
export default __webpack_public_path__ + "static/media/Preview.90cbf8a943ab0c3cf959cd46789ba54c.svg";
export { ForwardRef as ReactComponent };